<mat-card class="mb-2" *ngIf="data">
    <mat-card-content>
      <h2 class="info-title">{{data.title}}</h2>
  
      <div class="teachers-list">
        <app-person *ngFor="let person of data.persons" [data]="person" class="teacher"></app-person>
      </div>
    </mat-card-content>
</mat-card>
  